import * as React from "react";
import TelemetryContext from "logic/telemetry/TelemetryContext";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidCatch(error, info) {
    this.setState({ error, info });
    this.context.sendErrorReport(error);
  }
  render() {
    const { error, info } = this.state;
    const { FallbackComponent, children } = this.props;
    if (error) {
      return /* @__PURE__ */ React.createElement(FallbackComponent, { error, info });
    }
    return children;
  }
}
ErrorBoundary.contextType = TelemetryContext;
export default ErrorBoundary;
